import { CertificateQuestion, CertificateQuestionAnswerType } from 'src/types/CertificateQuestion'
import { MultipleChoiceAnswerTable } from './MultipleChoiceAnswerTable'

export function renderQuestionAnswers(
    question: CertificateQuestion,
    answer: CertificateQuestionAnswerType,
    onAnswerUpdate: (answer: CertificateQuestionAnswerType, isValidAnswer: boolean) => unknown,
) {
    switch (question.type) {
        case 'multiple_choice': {
            return <MultipleChoiceAnswerTable question={question} answer={answer} onAnswerUpdate={onAnswerUpdate} />
        }
    }
}

export function getInitialAnswer(type: CertificateQuestionAnswerType['type']): CertificateQuestionAnswerType {
    switch (type) {
        case 'multiple_choice': {
            return {
                type: 'multiple_choice',
                answers: {},
            }
        }
    }
}
